import * as ProductService from "@omni/services/product/product.service";
import { Product } from "@omni/types/api/product/bff/product.model";
import { ProductFieldSet } from "@omni/types/api/product/bff/shared/enums/productFieldSet.enum";

import { RepairabilityIndex } from "@/components/RepairabilityIndex/repairabilityIndex.types";
import { Config } from "@/utils/config.utils";

const GPC_LEGACY_REPAIRABILITY_INDEX_FEATURE_CODE_SUFFIX = ".0.150";
const GPC_REPAIRABILITY_INDEX_FEATURE_CODE_SUFFIX = ".0.622";

const getRepairabilityIndexValues = (
    product: Product<ProductFieldSet.Full>,
    feature: string
) => {
    const repairabilityIndexFeature = ProductService.getFeatureValue(
        product,
        feature
    );

    const imageUrl = repairabilityIndexFeature?.imageURL;

    if (!imageUrl) return null;

    const altText =
        repairabilityIndexFeature?.formattedValue || product.productTitle;

    return {
        imageUrl: imageUrl,
        altText: altText
    };
};

export const RepairabilityIndexAdapter = (
    product: Product<ProductFieldSet.Full>
): RepairabilityIndex | null => {
    const repairabilityIndexValues =
        getRepairabilityIndexValues(
            product,
            GPC_REPAIRABILITY_INDEX_FEATURE_CODE_SUFFIX
        ) ??
        getRepairabilityIndexValues(
            product,
            GPC_LEGACY_REPAIRABILITY_INDEX_FEATURE_CODE_SUFFIX
        );

    const documentUrl =
        product.repairabilityDocuments.find((doc) => doc.url)?.url ||
        Config["external-links"]["repairability-index"];

    if (!repairabilityIndexValues || !documentUrl) {
        return null;
    }

    return {
        imageUrl: repairabilityIndexValues.imageUrl,
        altText: repairabilityIndexValues.altText,
        documentUrl: documentUrl
    };
};
